export default {
  SAVE_RANK_DATA (state, data) {
    state[data.name] = data.data
  },
}
